import React from 'react';
import Navigation from '../components/Navigation';
import Process from '../components/Process';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const ProcessPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO title="Our Process" description="Learn how Manage Your Loans guides you through the loan process — from initial consultation to settlement." path="/process" />
      <Navigation />
      <div className="pt-16">
        <Process />
      </div>
      <Footer />
    </div>
  );
};

export default ProcessPage;
